module.exports = __webpack_public_path__ + "static/img/waiting_delivery.dd8deef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/waiting_delivery.png
// module id = Gp+l
// module chunks = 0